"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttemptSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const assessment_serializer_1 = require("./assessment.serializer");
const date_helper_1 = require("../../helpers/date.helper");
class AttemptSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(assessmentSerializer = new assessment_serializer_1.AssessmentSerializer()) {
        super();
        this.assessmentSerializer = assessmentSerializer;
    }
    serializeOne(data) {
        const hasFeedback = data.feedback && data.feedback.length;
        return {
            id: data.id,
            districtId: data.districtId,
            score: data.score,
            maxScore: data.maxScore,
            startedAt: (0, date_helper_1.toLocalDate)(data.startedAt),
            closedAt: (0, date_helper_1.toLocalDate)(data.closedAt),
            updatedAt: (0, date_helper_1.toLocalDate)(data.updatedAt),
            reopenedAt: (0, date_helper_1.toLocalDate)(data.reopenedAt),
            status: data.status,
            latest: data.latest,
            graded: data.graded,
            submittedBy: data.submittedBy,
            completedOnPaper: data.completedOnPaper,
            assigneeId: data.assigneeId,
            responses: data.responses,
            assessment: data.assessment ? this.assessmentSerializer.serializeOne(data.assessment) : null,
            feedback: hasFeedback ? data.feedback.map((f) => this.serializeFeedback(f)) : undefined,
            platformId: data.platformId,
            scoreSeen: data.scoreSeen,
            scoreAvailable: data.scoreAvailable,
        };
    }
    serializeFeedback({ id, itemExternalId, feedback, createdBy }) {
        return {
            id,
            itemExternalId,
            feedback,
            createdBy,
        };
    }
}
exports.AttemptSerializer = AttemptSerializer;
//# sourceMappingURL=attempt.serializer.js.map